import { Trans } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { View } from '@actual-app/components/view';

import { color, texto } from '#components/mobile/ui/tokens';

import { CaboNudos } from './CaboNudos';
import type { SerieCobro } from './cobros';

/** En «Evolución», como mucho tres comercios (los de más dinero). */
const MAX_COMERCIOS = 3;

/**
 * Vista «Recibos» de la tarjeta «Evolución» (Altamar): un cabo por comercio
 * con un nudo por recibo, dorados desde que subió. Netflix y Spotify en
 * «Suscripciones», cada uno con el suyo.
 */
export function RecibosGavi({ series }: { series: readonly SerieCobro[] }) {
  return (
    <View style={{ gap: 14, paddingTop: 4 }} data-testid="gavi-recibos">
      {series.slice(0, MAX_COMERCIOS).map(s => (
        <View key={s.clave} style={{ gap: 4 }}>
          <Text style={{ ...texto.etiqueta, color: color.fg3 }}>
            <Trans>What {{ name: s.comercio }} charges you</Trans>
          </Text>
          <CaboNudos serie={s} />
        </View>
      ))}
    </View>
  );
}
